const foodData = [
  {
    food: "M&M's Nature",
    type: "Collations",
    serving: "sachet",
    size: 1,
    weight: 48,
    protein: 3.02,
    fat: 10.66,
    carbohydrates: 32.74,
    calories: 228.48,
    sugar: null,
  },
  {
    food: "Riz (cuit)",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 158,
    protein: 4.25,
    fat: 0.44,
    carbohydrates: 44.51,
    calories: 205.4,
    sugar: null,
  },
  {
    food: "Avocat",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 146,
    protein: 2.9,
    fat: 21.4,
    carbohydrates: 12.5,
    calories: 233.6,
    sugar: 1,
  },
  {
    food: "Ilba (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 4.3,
    fat: 3.3,
    carbohydrates: 17.8,
    calories: 118,
    sugar: null,
  },
  {
    food: "Aloo (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "3 morceaux",
    size: 3,
    weight: 100,
    protein: 2.63,
    fat: 4.86,
    carbohydrates: 20.6,
    calories: 136,
    sugar: null,
  },
  {
    food: "Ananas",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 155,
    protein: 0.8,
    fat: 0.2,
    carbohydrates: 20.3,
    calories: 77.5,
    sugar: 14.4,
  },
  {
    food: "Ananas en Conserve",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 255,
    protein: 0.89,
    fat: 0.28,
    carbohydrates: 51.51,
    calories: 198.9,
    sugar: null,
  },
  {
    food: "Omelette",
    type: "Œufs",
    serving: "œuf",
    size: 1,
    weight: 61,
    protein: 6.5,
    fat: 7.3,
    carbohydrates: 0.4,
    calories: 95.8,
    sugar: 0.4,
  },
  {
    food: "Glace à la Vanille",
    type: "Collations",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 90,
    protein: 4.62,
    fat: 14.52,
    carbohydrates: 31.15,
    calories: 265.32,
    sugar: null,
  },
  {
    food: "Glace à la Fraise",
    type: "Collations",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 90,
    protein: 4.22,
    fat: 11.09,
    carbohydrates: 36.43,
    calories: 253.44,
    sugar: null,
  },
  {
    food: "Glace au Chocolat",
    type: "Collations",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 91,
    protein: 4.2,
    fat: 14.9,
    carbohydrates: 20.2,
    calories: 232,
    sugar: null,
  },
  {
    food: "Sandwich Glacé",
    type: "Collations",
    serving: "pièce",
    size: 1,
    weight: 63,
    protein: 3,
    fat: 6,
    carbohydrates: 27,
    calories: 170,
    sugar: null,
  },
  {
    food: "Petits Pois",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 160,
    protein: 8.6,
    fat: 0.4,
    carbohydrates: 25,
    calories: 134.4,
    sugar: 9.5,
  },
  {
    food: "Orange",
    type: "Fruits",
    serving: "1 moyenne",
    size: 1,
    weight: 131,
    protein: 1.2,
    fat: 0.2,
    carbohydrates: 15.4,
    calories: 61.6,
    sugar: 12.2,
  },
  {
    food: "Patate Douce",
    type: "Légumes",
    serving: "1 moyenne",
    size: 1,
    weight: 130,
    protein: 2,
    fat: 0.1,
    carbohydrates: 26.2,
    calories: 111.8,
    sugar: 5.4,
  },
  {
    food: "Persil",
    type: "Légumes",
    serving: "10 brins",
    size: 10,
    weight: 10,
    protein: 0.3,
    fat: 0.1,
    carbohydrates: 0.6,
    calories: 3.6,
    sugar: 0.1,
  },
  {
    food: "Lupins",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 166,
    protein: 25.8,
    fat: 4.8,
    carbohydrates: 16.4,
    calories: 197.5,
    sugar: null,
  },
  {
    food: "Dattes",
    type: "Fruits",
    serving: "4 morceaux",
    size: 4,
    weight: 32,
    protein: 0.8,
    fat: 0.1,
    carbohydrates: 24,
    calories: 90.2,
    sugar: 20.3,
  },
  {
    food: "Myrtilles",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 145,
    protein: 1.1,
    fat: 0.5,
    carbohydrates: 21,
    calories: 82.6,
    sugar: 14.4,
  },
  {
    food: "Mûres",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 144,
    protein: 2,
    fat: 0.7,
    carbohydrates: 13.8,
    calories: 61.9,
    sugar: 7,
  },
  {
    food: "Canneberges",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 95,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 11.6,
    calories: 43.7,
    sugar: 3.8,
  },
  {
    food: "Figue",
    type: "Fruits",
    serving: "1 moyenne",
    size: 1,
    weight: 50,
    protein: 0.4,
    fat: 0.2,
    carbohydrates: 9.6,
    calories: 37,
    sugar: 8.1,
  },
  {
    food: "Roquette",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 34,
    protein: 0.8,
    fat: null,
    carbohydrates: 0.4,
    calories: 3.7,
    sugar: 0.1,
  },
  {
    food: "Pêche",
    type: "Fruits",
    serving: "1 moyenne",
    size: 1,
    weight: 150,
    protein: 1.4,
    fat: 0.4,
    carbohydrates: 14.3,
    calories: 58.5,
    sugar: 12.6,
  },
  {
    food: "Pruneaux Secs",
    type: "Fruits",
    serving: "tasse (moitiés)",
    size: 0.5,
    weight: 160,
    protein: 5.8,
    fat: 1.2,
    carbohydrates: 98.1,
    calories: 382.4,
    sugar: 66.8,
  },
  {
    food: "Pourpier",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 43,
    protein: 0.6,
    fat: null,
    carbohydrates: 1.5,
    calories: 6.9,
    sugar: null,
  },
  {
    food: "Épinards",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 30,
    protein: 0.9,
    fat: 0.1,
    carbohydrates: 1.1,
    calories: 6.9,
    sugar: 0.1,
  },
  {
    food: "Melon Cantaloup",
    type: "Fruits",
    serving: "tasse (morceaux)",
    size: 1,
    weight: 177,
    protein: 1.5,
    fat: 0.3,
    carbohydrates: 14.4,
    calories: 60.2,
    sugar: 13.9,
  },
  {
    food: "Haricots Noirs",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 164,
    protein: 14.5,
    fat: 4.2,
    carbohydrates: 45,
    calories: 269,
    sugar: 7.9,
  },
  {
    food: "Haricots Rouges",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 177,
    protein: 15.3,
    fat: 0.9,
    carbohydrates: 40.4,
    calories: 224.8,
    sugar: 0.6,
  },
  {
    food: "Haricots Verts",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 110,
    protein: 2,
    fat: 0.1,
    carbohydrates: 7.8,
    calories: 34.1,
    sugar: 1.5,
  },
  {
    food: "Radis",
    type: "Légumes",
    serving: "tranches (1/2 tasse)",
    size: 0.5,
    weight: 58,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 2,
    calories: 9.3,
    sugar: 1.2,
  },
  {
    food: "Chou-fleur",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 100,
    protein: 2,
    fat: 0.1,
    carbohydrates: 5.3,
    calories: 25,
    sugar: 2.4,
  },
  {
    food: "Ciboulette",
    type: "Légumes",
    serving: "4 c. à café",
    size: 4,
    weight: 40,
    protein: 1,
    fat: null,
    carbohydrates: 6.7,
    calories: 28.8,
    sugar: null,
  },
  {
    food: "Cerises Aigres",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 103,
    protein: 1,
    fat: 0.3,
    carbohydrates: 12.5,
    calories: 51.5,
    sugar: 8.7,
  },
  {
    food: "Cerises Douces",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 117,
    protein: 1.2,
    fat: 0.2,
    carbohydrates: 18.7,
    calories: 73.7,
    sugar: 15,
  },
  {
    food: "Coriandre",
    type: "Légumes",
    serving: "9 brins",
    size: 9,
    weight: 20,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 0.7,
    calories: 4.6,
    sugar: 0.2,
  },
  {
    food: "Navet",
    type: "Légumes",
    serving: "tasse en tranches",
    size: 1,
    weight: 67,
    protein: 2.2,
    fat: 0.5,
    carbohydrates: 6.7,
    calories: 33.5,
    sugar: null,
  },
  {
    food: "Ammoush (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 6.84,
    fat: 1.7,
    carbohydrates: 26.81,
    calories: 149.9,
    sugar: null,
  },
  {
    food: "Papaye",
    type: "Fruits",
    serving: "1 moyenne",
    size: 1,
    weight: 304,
    protein: 1.9,
    fat: 0.4,
    carbohydrates: 29.8,
    calories: 118.6,
    sugar: 17.9,
  },
  {
    food: "Bajela (Haricots Traditionnels)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 6.2,
    fat: 1,
    carbohydrates: 16.3,
    calories: 99,
    sugar: null,
  },
  {
    food: "Aubergine",
    type: "Légumes",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 82,
    protein: 0.84,
    fat: 0.15,
    carbohydrates: 4.98,
    calories: 21.32,
    sugar: null,
  },
  {
    food: "Petits Pois Surgelés",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 63,
    protein: 1.8,
    fat: 0.1,
    carbohydrates: 4.8,
    calories: 26.5,
    sugar: 2.5,
  },
  {
    food: "M&M's Noisette",
    type: "Collations",
    serving: "1 sachet",
    size: 1,
    weight: 49,
    protein: 5.24,
    fat: 13.18,
    carbohydrates: 28.91,
    calories: 242.55,
    sugar: null,
  },
  {
    food: "Gombo",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 100,
    protein: 2,
    fat: 0.1,
    carbohydrates: 7,
    calories: 31,
    sugar: 1.2,
  },
  {
    food: "Bathith (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 2.6,
    fat: 6.4,
    carbohydrates: 71,
    calories: 352,
    sugar: null,
  },
  {
    food: "Riz Bukhari au Poulet",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 18.6,
    fat: 2.8,
    carbohydrates: 17.4,
    calories: 169,
    sugar: null,
  },
  {
    food: "Riz Bukhari à l'Agneau",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 22.49,
    fat: 1.32,
    carbohydrates: 7.83,
    calories: 133,
    sugar: null,
  },
  {
    food: "Bakhsam (Pain Traditionnel)",
    type: "Pain & Céréales",
    serving: "pièce",
    size: 1,
    weight: 10,
    protein: 1.2,
    fat: 0.95,
    carbohydrates: 6.84,
    calories: 41.2,
    sugar: null,
  },
  {
    food: "Burger au Poulet",
    type: "Plats Traditionnels",
    serving: "1 moyen",
    size: 1,
    weight: 100,
    protein: 8.5,
    fat: 2.8,
    carbohydrates: 33.4,
    calories: 193,
    sugar: null,
  },
  {
    food: "Burger au Bœuf",
    type: "Plats Traditionnels",
    serving: "1 moyen",
    size: 1,
    weight: 100,
    protein: 10,
    fat: 4.3,
    carbohydrates: 33.3,
    calories: 176.2,
    sugar: null,
  },
  {
    food: "Pringles Saveur Oignon",
    type: "Collations",
    serving: "petite boîte",
    size: 1,
    weight: 50,
    protein: 4.05,
    fat: 16.949,
    carbohydrates: 25.75,
    calories: 265.5,
    sugar: null,
  },
  {
    food: "Pringles Saveur Fromage",
    type: "Collations",
    serving: "petite boîte",
    size: 1,
    weight: 50,
    protein: 3.49,
    fat: 18.5,
    carbohydrates: 25.31,
    calories: 275.5,
    sugar: null,
  },
  {
    food: "Brocoli",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 91,
    protein: 2.6,
    fat: 0.3,
    carbohydrates: 6,
    calories: 30.9,
    sugar: 1.5,
  },
  {
    food: "Biryani au Poulet",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 15.38,
    fat: 2.5,
    carbohydrates: 14,
    calories: 141.2,
    sugar: null,
  },
  {
    food: "Biryani à l'Agneau",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 17.99,
    fat: 2.63,
    carbohydrates: 13.05,
    calories: 142.9,
    sugar: null,
  },
  {
    food: "Biscuit au Fromage",
    type: "Pain & Céréales",
    serving: "1 pièce",
    size: 1,
    weight: 1,
    protein: 0.1,
    fat: 0.25,
    carbohydrates: 0.58,
    calories: 5.03,
    sugar: null,
  },
  {
    food: "Biscuit au Blé",
    type: "Pain & Céréales",
    serving: "1 pièce",
    size: 1,
    weight: 2,
    protein: 0.17,
    fat: 0.41,
    carbohydrates: 1.3,
    calories: 9.46,
    sugar: null,
  },
  {
    food: "Cracker Salé",
    type: "Pain & Céréales",
    serving: "1 pièce",
    size: 1,
    weight: 3,
    protein: 0.22,
    fat: 0.76,
    carbohydrates: 1.83,
    calories: 15.06,
    sugar: null,
  },
  {
    food: "Oignon",
    type: "Légumes",
    serving: "tasse (haché)",
    size: 1,
    weight: 160,
    protein: 1.8,
    fat: 0.2,
    carbohydrates: 14.9,
    calories: 64,
    sugar: 6.8,
  },
  {
    food: "Canard Rôti (sans peau)",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 85,
    protein: 20,
    fat: 9.5,
    carbohydrates: 0,
    calories: 170.8,
    sugar: 0,
  },
  {
    food: "Canard Rôti (avec peau)",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 85,
    protein: 16.1,
    fat: 24.1,
    carbohydrates: 0,
    calories: 286.4,
    sugar: 0,
  },
  {
    food: "Pomme de Terre",
    type: "Légumes",
    serving: "1 moyenne",
    size: 1,
    weight: 213,
    protein: 4.3,
    fat: 0.2,
    carbohydrates: 37.2,
    calories: 164,
    sugar: 1.7,
  },
  {
    food: "Frites",
    type: "Plats Traditionnels",
    serving: "50 pièces",
    size: 50,
    weight: 100,
    protein: 2.8,
    fat: 5.6,
    carbohydrates: 31.4,
    calories: 187,
    sugar: null,
  },
  {
    food: "Baqsamat (Pain Grillé)",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 108,
    protein: 14.4,
    fat: 5.7,
    carbohydrates: 77.7,
    calories: 426.6,
    sugar: null,
  },
  {
    food: "Balaleet (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 5.5,
    fat: 6.1,
    carbohydrates: 30.4,
    calories: 199,
    sugar: null,
  },
  {
    food: "Bourrache",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 33,
    protein: 0.3,
    fat: null,
    carbohydrates: 1.1,
    calories: 5,
    sugar: null,
  },
  {
    food: "Blanc d'Œuf",
    type: "Œufs",
    serving: "blanc d'œuf",
    size: 1,
    weight: 33,
    protein: 3.6,
    fat: 0.1,
    carbohydrates: 0.2,
    calories: 15.8,
    sugar: 0.2,
  },
  {
    food: "Œuf d'Oie",
    type: "Œufs",
    serving: "œuf",
    size: 1,
    weight: 144,
    protein: 20,
    fat: 19.1,
    carbohydrates: 1.9,
    calories: 266.4,
    sugar: 1.4,
  },
  {
    food: "Œuf de Dinde",
    type: "Œufs",
    serving: "œuf",
    size: 1,
    weight: 79,
    protein: 10.8,
    fat: 9.4,
    carbohydrates: 0.9,
    calories: 135.1,
    sugar: null,
  },
  {
    food: "Œuf de Caille",
    type: "Œufs",
    serving: "œuf",
    size: 1,
    weight: 9,
    protein: 1.2,
    fat: 1,
    carbohydrates: null,
    calories: 14.2,
    sugar: null,
  },
  {
    food: "Œuf de Canard",
    type: "Œufs",
    serving: "œuf",
    size: 1,
    weight: 70,
    protein: 9,
    fat: 9.6,
    carbohydrates: 1,
    calories: 129.5,
    sugar: 0.7,
  },
  {
    food: "Œuf de Poule",
    type: "Œufs",
    serving: "œuf",
    size: 1,
    weight: 50,
    protein: 6.3,
    fat: 5,
    carbohydrates: 0.4,
    calories: 71.5,
    sugar: 0.4,
  },
  {
    food: "Œuf en Poudre",
    type: "Œufs",
    serving: "c. à café",
    size: 1,
    weight: 5,
    protein: 2.4,
    fat: 2.2,
    carbohydrates: 0.1,
    calories: 30.8,
    sugar: null,
  },
  {
    food: "Œuf Brouillé au Lait",
    type: "Œufs",
    serving: "œuf",
    size: 1,
    weight: 61,
    protein: 6.8,
    fat: 7.4,
    carbohydrates: 1.3,
    calories: 101.9,
    sugar: 1.1,
  },
  {
    food: "Œuf Dur",
    type: "Œufs",
    serving: "œuf",
    size: 1,
    weight: 50,
    protein: 6.3,
    fat: 5.3,
    carbohydrates: 0.6,
    calories: 77.5,
    sugar: 0.6,
  },
  {
    food: "Œuf au Plat",
    type: "Œufs",
    serving: "œuf",
    size: 1,
    weight: 46,
    protein: 6.3,
    fat: 7,
    carbohydrates: 0.4,
    calories: 90.2,
    sugar: 0.4,
  },
  {
    food: "Taboulé",
    type: "Légumes",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28.35,
    protein: 1,
    fat: 2,
    carbohydrates: 2,
    calories: 30,
    sugar: null,
  },
  {
    food: "Pomme",
    type: "Fruits",
    serving: "1 moyenne",
    size: 1,
    weight: 138,
    protein: 0.4,
    fat: 0.2,
    carbohydrates: 19.1,
    calories: 71.8,
    sugar: 14.3,
  },
  {
    food: "Pomme Séchée",
    type: "Fruits",
    serving: "tranche",
    size: 1,
    weight: 98,
    protein: 0.9,
    fat: 0.3,
    carbohydrates: 64.6,
    calories: 238.1,
    sugar: 56,
  },
  {
    food: "Tikka d'Agneau",
    type: "Plats Traditionnels",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 35.3,
    fat: 3.9,
    carbohydrates: 1.2,
    calories: 181,
    sugar: null,
  },
  {
    food: "Tamarin",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 120,
    protein: 3.4,
    fat: 0.7,
    carbohydrates: 75,
    calories: 286.8,
    sugar: 68.9,
  },
  {
    food: "Mûres Blanches",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 123,
    protein: 1.5,
    fat: 0.8,
    carbohydrates: 14.7,
    calories: 64,
    sugar: 5.4,
  },
  {
    food: "Cracker Caramel (Tuc)",
    type: "Collations",
    serving: "pièce",
    size: 1,
    weight: 57,
    protein: 3.08,
    fat: 13.4,
    carbohydrates: 37.45,
    calories: 272.46,
    sugar: null,
  },
  {
    food: "Tharid (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 100,
    protein: 6.8,
    fat: 3.5,
    carbohydrates: 12.1,
    calories: 107,
    sugar: null,
  },
  {
    food: "Ail",
    type: "Légumes",
    serving: "3 gousses",
    size: 3,
    weight: 9,
    protein: 0.6,
    fat: null,
    carbohydrates: 3,
    calories: 13.4,
    sugar: 0.1,
  },
  {
    food: "Parmesan Râpé",
    type: "Produits Laitiers",
    serving: "c. à café",
    size: 1,
    weight: 5,
    protein: 1.9,
    fat: 1.4,
    carbohydrates: 0.2,
    calories: 21.6,
    sugar: null,
  },
  {
    food: "Fromage Cheddar",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 7,
    fat: 9.3,
    carbohydrates: 0.4,
    calories: 112.8,
    sugar: 0.1,
  },
  {
    food: "Fromage Halloumi",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 100,
    protein: 16.4,
    fat: 29.4,
    carbohydrates: 8.2,
    calories: 363,
    sugar: null,
  },
  {
    food: "Fromage de Chèvre Dur",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 8.5,
    fat: 10,
    carbohydrates: 0.6,
    calories: 126.6,
    sugar: 0.6,
  },
  {
    food: "Fromage de Chèvre Frais",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 5.2,
    fat: 5.9,
    carbohydrates: 0.2,
    calories: 75,
    sugar: 0.2,
  },
  {
    food: "Fromage de Chèvre Demi-sec",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 6,
    fat: 8.4,
    carbohydrates: 0.7,
    calories: 101.9,
    sugar: 0.7,
  },
  {
    food: "Ricotta Allégée",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 124,
    protein: 14.1,
    fat: 9.8,
    carbohydrates: 6.4,
    calories: 171.1,
    sugar: 0.4,
  },
  {
    food: "Ricotta Entière",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 124,
    protein: 14,
    fat: 16.1,
    carbohydrates: 3.8,
    calories: 215.8,
    sugar: 0.3,
  },
  {
    food: "Fromage Feta",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 4,
    fat: 6,
    carbohydrates: 1.1,
    calories: 73.9,
    sugar: 1.1,
  },
  {
    food: "Fromage à la Crème",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 15,
    protein: 0.9,
    fat: 5.1,
    carbohydrates: 0.6,
    calories: 51.3,
    sugar: null,
  },
  {
    food: "Fromage à la Crème Sans Matières Grasses",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 4.4,
    fat: 0.3,
    carbohydrates: 2.1,
    calories: 29.4,
    sugar: 0.1,
  },
  {
    food: "Fromage à la Crème Allégé",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 2.2,
    fat: 4.3,
    carbohydrates: 2.3,
    calories: 56.3,
    sugar: 0.1,
  },
  {
    food: "Fromage Blanc (<5% MG)",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 226,
    protein: 23.4,
    fat: 0.7,
    carbohydrates: 15.1,
    calories: 162.7,
    sugar: 4.2,
  },
  {
    food: "Mozzarella Entière",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 6.2,
    fat: 6.3,
    carbohydrates: 0.6,
    calories: 84,
    sugar: 0.3,
  },
  {
    food: "Mozzarella Sans Matières Grasses",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 8.9,
    fat: 0,
    carbohydrates: 1,
    calories: 41.7,
    sugar: 0.4,
  },
  {
    food: "Mozzarella Allégée",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 6.8,
    fat: 4.5,
    carbohydrates: 0.8,
    calories: 71.1,
    sugar: 0.3,
  },
  {
    food: "Pamplemousse",
    type: "Fruits",
    serving: "1/2 moyen",
    size: 0.5,
    weight: 118,
    protein: 0.7,
    fat: 0.1,
    carbohydrates: 9.5,
    calories: 37.8,
    sugar: 8.2,
  },
  {
    food: "Carotte",
    type: "Légumes",
    serving: "1 pièce",
    size: 1,
    weight: 72,
    protein: 0.7,
    fat: 0.2,
    carbohydrates: 6.9,
    calories: 29.5,
    sugar: 3.3,
  },
  {
    food: "Mini Carotte",
    type: "Légumes",
    serving: "1 moyenne",
    size: 1,
    weight: 10,
    protein: 0.1,
    fat: null,
    carbohydrates: 0.8,
    calories: 3.5,
    sugar: 0.5,
  },
  {
    food: "Jalleb (Dessert Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 3.1,
    fat: 25,
    carbohydrates: 24,
    calories: 333,
    sugar: null,
  },
  {
    food: "Goyave",
    type: "Fruits",
    serving: "1 moyenne",
    size: 1,
    weight: 90,
    protein: 2.3,
    fat: 0.9,
    carbohydrates: 12.9,
    calories: 61.2,
    sugar: 8,
  },
  {
    food: "Noix de Coco",
    type: "Fruits à Coque",
    serving: "2 c. à soupe",
    size: 2,
    weight: 45,
    protein: 1.5,
    fat: 15.1,
    carbohydrates: 6.9,
    calories: 159.3,
    sugar: 2.8,
  },
  {
    food: "Noix de Coco Séchée",
    type: "Fruits à Coque",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 1.9,
    fat: 18.1,
    carbohydrates: 6.6,
    calories: 184.8,
    sugar: 2.1,
  },
  {
    food: "Grains de Maïs",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 166,
    protein: 15.6,
    fat: 7.9,
    carbohydrates: 123.3,
    calories: 605.9,
    sugar: null,
  },
  {
    food: "Grains de Blé",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 192,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: null,
  },
  {
    food: "Hasoo (Bouillie Traditionnelle)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 2.9,
    fat: 7.1,
    carbohydrates: 14.9,
    calories: 135,
    sugar: null,
  },
  {
    food: "Lait Évaporé",
    type: "Produits Laitiers",
    serving: "6 c. à soupe",
    size: 6,
    weight: 100,
    protein: 7,
    fat: 7.9,
    carbohydrates: 9.7,
    calories: 137,
    sugar: null,
  },
  {
    food: "Lait de Brebis",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 245,
    protein: 14.7,
    fat: 17.2,
    carbohydrates: 13.1,
    calories: 264.6,
    sugar: null,
  },
  {
    food: "Lait de Chèvre",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 244,
    protein: 8.7,
    fat: 10.1,
    carbohydrates: 10.9,
    calories: 168.4,
    sugar: 10.9,
  },
  {
    food: "Barre de Lait Chocolaté",
    type: "Collations",
    serving: "1 boîte",
    size: 1,
    weight: 44,
    protein: 3.04,
    fat: 13.46,
    carbohydrates: 26.09,
    calories: 225.72,
    sugar: null,
  },
  {
    food: "Lait au Chocolat Allégé",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 250,
    protein: 7.5,
    fat: 4.8,
    carbohydrates: 30.3,
    calories: 190,
    sugar: 23.9,
  },
  {
    food: "Lait à la Fraise",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 266,
    protein: 8,
    fat: 8.2,
    carbohydrates: 32.7,
    calories: 234.1,
    sugar: null,
  },
  {
    food: "Lait en Poudre",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 32,
    protein: 8.4,
    fat: 8.5,
    carbohydrates: 12.3,
    calories: 158.7,
    sugar: 12.3,
  },
  {
    food: "Lait de Coco",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 240,
    protein: 5.5,
    fat: 57.2,
    carbohydrates: 13.3,
    calories: 552,
    sugar: 8,
  },
  {
    food: "Lait Demi-écrémé",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 244,
    protein: 8.1,
    fat: 4.8,
    carbohydrates: 11.4,
    calories: 122,
    sugar: 12.3,
  },
  {
    food: "Lait Entier",
    type: "Produits Laitiers",
    serving: "1/3 tasse",
    size: 0.3,
    weight: 100,
    protein: 3.5,
    fat: 3,
    carbohydrates: 5.5,
    calories: 64,
    sugar: null,
  },
  {
    food: "Lait Évaporé Écrémé en Conserve",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 32,
    protein: 2.4,
    fat: 0.1,
    carbohydrates: 3.6,
    calories: 25,
    sugar: 3.6,
  },
  {
    food: "Lait Concentré Sucré",
    type: "Produits Laitiers",
    serving: "2 c. à soupe",
    size: 2,
    weight: 38,
    protein: 3,
    fat: 3.3,
    carbohydrates: 20.7,
    calories: 122,
    sugar: 20.7,
  },
  {
    food: "Lait Écrémé",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 245,
    protein: 8.3,
    fat: 0.2,
    carbohydrates: 12.2,
    calories: 83.3,
    sugar: 12.5,
  },
  {
    food: "Pigeon",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 21.8,
    fat: 3.3,
    carbohydrates: 0,
    calories: 117.8,
    sugar: null,
  },
  {
    food: "Pigeon (sans peau)",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 85,
    protein: 14.9,
    fat: 6.4,
    carbohydrates: 0,
    calories: 120.7,
    sugar: null,
  },
  {
    food: "Pigeon Cuit",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 85,
    protein: 20.3,
    fat: 11,
    carbohydrates: 0,
    calories: 186.2,
    sugar: 0,
  },
  {
    food: "Pigeon Frit",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 27.8,
    fat: 4.2,
    carbohydrates: 0,
    calories: 150,
    sugar: null,
  },
  {
    food: "Houmous",
    type: "Légumes",
    serving: "c. à soupe",
    size: 1,
    weight: 14,
    protein: 1.1,
    fat: 1.3,
    carbohydrates: 2,
    calories: 23.2,
    sugar: null,
  },
  {
    food: "Pain Blanc",
    type: "Pain & Céréales",
    serving: "1/4 miche",
    size: 0.25,
    weight: 25,
    protein: 1.9,
    fat: 0.8,
    carbohydrates: 12.7,
    calories: 66.5,
    sugar: 1.1,
  },
  {
    food: "Pain Blanc Grillé",
    type: "Pain & Céréales",
    serving: "1/4 miche",
    size: 0.25,
    weight: 22,
    protein: 2,
    fat: 0.9,
    carbohydrates: 12,
    calories: 64.5,
    sugar: 1,
  },
  {
    food: "Pain Complet",
    type: "Pain & Céréales",
    serving: "1/4 miche",
    size: 0.25,
    weight: 28,
    protein: 3.6,
    fat: 0.9,
    carbohydrates: 11.6,
    calories: 69.2,
    sugar: 1.6,
  },
  {
    food: "Pain à l'Avoine",
    type: "Pain & Céréales",
    serving: "petite tranche",
    size: 1,
    weight: 27,
    protein: 2.3,
    fat: 1.2,
    carbohydrates: 13.1,
    calories: 72.6,
    sugar: 0,
  },
  {
    food: "Pain au Son d'Avoine",
    type: "Pain & Céréales",
    serving: "petite tranche",
    size: 1,
    weight: 30,
    protein: 3.1,
    fat: 1.3,
    carbohydrates: 11.9,
    calories: 70.8,
    sugar: 0,
  },
  {
    food: "Pain au Fromage",
    type: "Pain & Céréales",
    serving: "pièce",
    size: 1,
    weight: 66,
    protein: 4.69,
    fat: 12.08,
    carbohydrates: 28.84,
    calories: 237.6,
    sugar: null,
  },
  {
    food: "Pain au Son",
    type: "Pain & Céréales",
    serving: "1/4 miche",
    size: 0.25,
    weight: 36,
    protein: 3.2,
    fat: 1.2,
    carbohydrates: 17.2,
    calories: 89.3,
    sugar: 3.5,
  },
  {
    food: "Petit Pain Blanc",
    type: "Pain & Céréales",
    serving: "1 moyen",
    size: 1,
    weight: 28,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 2.2,
  },
  {
    food: "Petit Pain Complet",
    type: "Pain & Céréales",
    serving: "1 moyen",
    size: 1,
    weight: 36,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 0.6,
  },
  {
    food: "Pain Burger",
    type: "Pain & Céréales",
    serving: "1 pièce",
    size: 1,
    weight: 43,
    protein: 4.1,
    fat: 1.9,
    carbohydrates: 21.3,
    calories: 120,
    sugar: 2.3,
  },
  {
    food: "Baguette",
    type: "Pain & Céréales",
    serving: "petite tranche",
    size: 1,
    weight: 32,
    protein: 3.8,
    fat: 0.6,
    carbohydrates: 18.1,
    calories: 92.5,
    sugar: 1.1,
  },
  {
    food: "Khabeesa (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 3.5,
    fat: 6.3,
    carbohydrates: 58.6,
    calories: 305,
    sugar: null,
  },
  {
    food: "Khanfaroush (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "3 morceaux",
    size: 3,
    weight: 100,
    protein: 6.3,
    fat: 10.1,
    carbohydrates: 50.1,
    calories: 316,
    sugar: null,
  },
  {
    food: "Concombre",
    type: "Légumes",
    serving: "1 grand",
    size: 1,
    weight: 301,
    protein: 2,
    fat: 0.3,
    carbohydrates: 10.9,
    calories: 45.2,
    sugar: 5,
  },
  {
    food: "Cornichon Aigre",
    type: "Légumes",
    serving: "1 tranche",
    size: 1,
    weight: 7,
    protein: 0.02,
    fat: 0.01,
    carbohydrates: 0.16,
    calories: 0.77,
    sugar: null,
  },
  {
    food: "Dal (Curry de Lentilles)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 4.5,
    fat: 2.5,
    carbohydrates: 13.2,
    calories: 93,
    sugar: null,
  },
  {
    food: "Poulet",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 85,
    protein: 18.2,
    fat: 2.6,
    carbohydrates: 0,
    calories: 101.2,
    sugar: 0,
  },
  {
    food: "Poulet en Conserve",
    type: "Viandes",
    serving: "boîte",
    size: 1,
    weight: 142,
    protein: 30.9,
    fat: 11.3,
    carbohydrates: 0,
    calories: 234.3,
    sugar: 0,
  },
  {
    food: "Farine d'Avoine",
    type: "Pain & Céréales",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 3.6,
    fat: 1.8,
    carbohydrates: 18.9,
    calories: 105,
    sugar: null,
  },
  {
    food: "Farine d'Avoine Cuite",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 234,
    protein: 5.5,
    fat: 3.2,
    carbohydrates: 27.3,
    calories: 159.1,
    sugar: null,
  },
  {
    food: "Maïs Frais",
    type: "Légumes",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 140,
    protein: 3.68,
    fat: 1.02,
    carbohydrates: 39.07,
    calories: 176.4,
    sugar: null,
  },
  {
    food: "Maïs en Conserve Sucré",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 164,
    protein: 4.3,
    fat: 1.64,
    carbohydrates: 30.49,
    calories: 132.84,
    sugar: null,
  },
  {
    food: "Crevettes",
    type: "Viandes",
    serving: "5 pièces",
    size: 5,
    weight: 100,
    protein: 19.7,
    fat: 0.8,
    carbohydrates: 0,
    calories: 87.1,
    sugar: null,
  },
  {
    food: "Crevettes Frites",
    type: "Viandes",
    serving: "3 pièces moyennes",
    size: 3,
    weight: 85,
    protein: 18.17,
    fat: 10.43,
    carbohydrates: 9.74,
    calories: 205.71,
    sugar: null,
  },
  {
    food: "Corn Flakes Sucrés",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 38,
    protein: 2.014,
    fat: 0.532,
    carbohydrates: 34.24,
    calories: 148.58,
    sugar: null,
  },
  {
    food: "Corn Flakes Nature",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 28,
    protein: 1.84,
    fat: 0.199,
    carbohydrates: 24.22,
    calories: 102.2,
    sugar: null,
  },
  {
    food: "Yaourt",
    type: "Produits Laitiers",
    serving: "1/3 tasse",
    size: 0.3,
    weight: 100,
    protein: 3.2,
    fat: 2.6,
    carbohydrates: 5.4,
    calories: 59,
    sugar: null,
  },
  {
    food: "Yaourt Allégé",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 227,
    protein: 11.9,
    fat: 3.5,
    carbohydrates: 16,
    calories: 143,
    sugar: 16,
  },
  {
    food: "Yaourt Allégé à la Vanille",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 227,
    protein: 11.2,
    fat: 2.8,
    carbohydrates: 31.3,
    calories: 193,
    sugar: 31.3,
  },
  {
    food: "Yaourt Allégé à la Fraise",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 227,
    protein: 9,
    fat: 2.6,
    carbohydrates: 42.3,
    calories: 224.7,
    sugar: 42.3,
  },
  {
    food: "Yaourt Sans Matières Grasses",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 227,
    protein: 13,
    fat: 0.4,
    carbohydrates: 17.4,
    calories: 127.1,
    sugar: 17.4,
  },
  {
    food: "Yaourt au Chocolat Sans Matières Grasses",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 227,
    protein: 8,
    fat: 0,
    carbohydrates: 53.4,
    calories: 245.2,
    sugar: 34,
  },
  {
    food: "Yaourt aux Fruits Sans Matières Grasses",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 227,
    protein: 10,
    fat: 0.5,
    carbohydrates: 43.1,
    calories: 215.6,
    sugar: 43.1,
  },
  {
    food: "Margarine (non salée)",
    type: "Matières Grasses",
    serving: "c. à café",
    size: 1,
    weight: 4.7,
    protein: 0.02,
    fat: 3.77,
    carbohydrates: 0.02,
    calories: 33.56,
    sugar: null,
  },
  {
    food: "Margarine (salée)",
    type: "Matières Grasses",
    serving: "c. à café",
    size: 1,
    weight: 4.7,
    protein: 0.04,
    fat: 3.78,
    carbohydrates: 0.04,
    calories: 33.78,
    sugar: null,
  },
  {
    food: "Huile de Maïs",
    type: "Matières Grasses",
    serving: "c. à café",
    size: 1,
    weight: 13.64,
    protein: 0,
    fat: 13.64,
    carbohydrates: 0,
    calories: 120.55,
    sugar: null,
  },
  {
    food: "Huile d'Olive",
    type: "Matières Grasses",
    serving: "c. à café",
    size: 1,
    weight: 13.51,
    protein: 0,
    fat: 13.51,
    carbohydrates: 0,
    calories: 119.44,
    sugar: null,
  },
  {
    food: "Huile de Palme",
    type: "Matières Grasses",
    serving: "c. à café",
    size: 1,
    weight: 13.64,
    protein: 0,
    fat: 13.64,
    carbohydrates: 0,
    calories: 120.55,
    sugar: null,
  },
  {
    food: "Huile de Tournesol",
    type: "Matières Grasses",
    serving: "c. à café",
    size: 1,
    weight: 13.64,
    protein: 0,
    fat: 13.64,
    carbohydrates: 0,
    calories: 120.55,
    sugar: null,
  },
  {
    food: "Olives en Conserve",
    type: "Légumes",
    serving: "pièce",
    size: 1,
    weight: 8.3,
    protein: 0.08,
    fat: 0.57,
    carbohydrates: 0.47,
    calories: 6.72,
    sugar: null,
  },
  {
    food: "Sagou",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 1,
    fat: 2.2,
    carbohydrates: 25.5,
    calories: 126,
    sugar: null,
  },
  {
    food: "Saucisse",
    type: "Viandes",
    serving: "pièce",
    size: 1,
    weight: 57,
    protein: 6.84,
    fat: 16.25,
    carbohydrates: 1.03,
    calories: 179.55,
    sugar: null,
  },
  {
    food: "Sucre Blanc",
    type: "Pain & Céréales",
    serving: "c. à café",
    size: 1,
    weight: 4,
    protein: 0,
    fat: 0,
    carbohydrates: 3.99,
    calories: 15.48,
    sugar: null,
  },
  {
    food: "Sucre Roux",
    type: "Pain & Céréales",
    serving: "c. à café",
    size: 1,
    weight: 3,
    protein: 0,
    fat: 0,
    carbohydrates: 2.92,
    calories: 11.28,
    sugar: null,
  },
  {
    food: "Salade de Légumes",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 100,
    protein: 0.93,
    fat: 1.86,
    carbohydrates: 4.51,
    calories: 39.59,
    sugar: null,
  },
  {
    food: "Saumon en Conserve",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 85,
    protein: 17.4,
    fat: 6.21,
    carbohydrates: 0,
    calories: 130,
    sugar: null,
  },
  {
    food: "Caille Cuite",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 85,
    protein: 21.3,
    fat: 12,
    carbohydrates: 0,
    calories: 198.9,
    sugar: 0,
  },
  {
    food: "Sambusa au Fromage",
    type: "Plats Traditionnels",
    serving: "3 pièces",
    size: 3,
    weight: 100,
    protein: 10.4,
    fat: 19.8,
    carbohydrates: 49.7,
    calories: 418.4,
    sugar: null,
  },
  {
    food: "Sambusa aux Légumes",
    type: "Plats Traditionnels",
    serving: "4 pièces",
    size: 4,
    weight: 100,
    protein: 5.07,
    fat: 13.61,
    carbohydrates: 33.29,
    calories: 275,
    sugar: null,
  },
  {
    food: "Vivaneau Rouge",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 85,
    protein: 22.37,
    fat: 1.45,
    carbohydrates: 0,
    calories: 108.81,
    sugar: null,
  },
  {
    food: "Thon en Conserve",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 85,
    protein: 21.68,
    fat: 0.69,
    carbohydrates: 0,
    calories: 98.61,
    sugar: null,
  },
  {
    food: "Poisson Frit",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 23.7,
    fat: 13,
    carbohydrates: null,
    calories: 211,
    sugar: null,
  },
  {
    food: "Snickers",
    type: "Collations",
    serving: "pièce",
    size: 1,
    weight: 61,
    protein: 5.86,
    fat: 13.6,
    carbohydrates: 36.78,
    calories: 277.55,
    sugar: null,
  },
  {
    food: "Thé (sans sucre)",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 236,
    protein: 0,
    fat: 0,
    carbohydrates: 0.06,
    calories: 0.3,
    sugar: null,
  },
  {
    food: "Thé Glacé",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 236.6,
    protein: 0,
    fat: 0,
    carbohydrates: 28.59,
    calories: 118.3,
    sugar: null,
  },
  {
    food: "Thé Sucré",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 236,
    protein: 0.03,
    fat: 0,
    carbohydrates: 2.75,
    calories: 11.01,
    sugar: null,
  },
  {
    food: "Pringles Original",
    type: "Collations",
    serving: "petite boîte",
    size: 1,
    weight: 50,
    protein: 2.95,
    fat: 19.21,
    carbohydrates: 25.5,
    calories: 278.99,
    sugar: null,
  },
  {
    food: "Chips Saveur Fromage",
    type: "Collations",
    serving: "petit sachet",
    size: 1,
    weight: 25,
    protein: 2.125,
    fat: 6.8,
    carbohydrates: 14.43,
    calories: 124,
    sugar: null,
  },
  {
    food: "Chips Non Salées",
    type: "Collations",
    serving: "petit sachet",
    size: 1,
    weight: 25,
    protein: 1.6,
    fat: 8.84,
    carbohydrates: 12.96,
    calories: 130.75,
    sugar: null,
  },
  {
    food: "Chips Salées",
    type: "Collations",
    serving: "petit sachet",
    size: 1,
    weight: 25,
    protein: 1.75,
    fat: 8.66,
    carbohydrates: 13.23,
    calories: 134,
    sugar: null,
  },
  {
    food: "Chips Soufflées (Meno)",
    type: "Collations",
    serving: "petit sachet",
    size: 1,
    weight: 25,
    protein: 1.682,
    fat: 9.525,
    carbohydrates: 12.889,
    calories: 137.94,
    sugar: null,
  },
  {
    food: "Sirop d'Orange",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 247.79,
    protein: 0,
    fat: 0,
    carbohydrates: 31.96,
    calories: 126.37,
    sugar: null,
  },
  {
    food: "Boisson Aromatisée aux Fruits",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 192,
    protein: 2.11,
    fat: 3.84,
    carbohydrates: 58.37,
    calories: 264.96,
    sugar: null,
  },
  {
    food: "Sirop de Raisin",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 250.18,
    protein: 0,
    fat: 0,
    carbohydrates: 28.77,
    calories: 112.58,
    sugar: null,
  },
  {
    food: "Sirop de Citron",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 266,
    protein: 0,
    fat: 0,
    carbohydrates: 28.73,
    calories: 11172,
    sugar: null,
  },
  {
    food: "Poisson Sha'ri",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 19.7,
    fat: 1.1,
    carbohydrates: 0,
    calories: 89.8,
    sugar: null,
  },
  {
    food: "Poisson Sha'ri Frit",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 25.9,
    fat: 7,
    carbohydrates: 0,
    calories: 167,
    sugar: null,
  },
  {
    food: "Betterave",
    type: "Légumes",
    serving: "tranches (1/2 tasse)",
    size: 0.5,
    weight: 68,
    protein: 1.1,
    fat: 0.1,
    carbohydrates: 6.5,
    calories: 29.2,
    sugar: 4.6,
  },
  {
    food: "Shawarma au Poulet",
    type: "Plats Traditionnels",
    serving: "1 pièce",
    size: 1,
    weight: 100,
    protein: 20.6,
    fat: 5.2,
    carbohydrates: 23.9,
    calories: 224.9,
    sugar: null,
  },
  {
    food: "Shawarma à la Viande",
    type: "Plats Traditionnels",
    serving: "1 pièce",
    size: 1,
    weight: 100,
    protein: 20,
    fat: 6.4,
    carbohydrates: 22.2,
    calories: 227.2,
    sugar: null,
  },
  {
    food: "Flocons d'Avoine Quaker",
    type: "Pain & Céréales",
    serving: "2,5 c. à café",
    size: 2.5,
    weight: 40,
    protein: 6.8,
    fat: 3.2,
    carbohydrates: 25.2,
    calories: 145.6,
    sugar: null,
  },
  {
    food: "Flocons d'Avoine Quaker (cuits à l'eau)",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 234,
    protein: 4.8,
    fat: 2.2,
    carbohydrates: 17.5,
    calories: 100.6,
    sugar: null,
  },
  {
    food: "Flocons d'Avoine Cuits",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 219,
    protein: 7,
    fat: 1.9,
    carbohydrates: 25.1,
    calories: 87.6,
    sugar: null,
  },
  {
    food: "Chips de Banane",
    type: "Collations",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 0.6,
    fat: 9.4,
    carbohydrates: 16.4,
    calories: 145.3,
    sugar: 9.9,
  },
  {
    food: "Poisson Safi",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 18.9,
    fat: 7.3,
    carbohydrates: 0.1,
    calories: 141.8,
    sugar: null,
  },
  {
    food: "Poisson Safi Grillé",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 27.3,
    fat: 4.3,
    carbohydrates: 0,
    calories: 148.9,
    sugar: null,
  },
  {
    food: "Blanc de Poulet Rôti",
    type: "Viandes",
    serving: "½ petit blanc de poulet",
    size: 0.5,
    weight: 85,
    protein: 26.35,
    fat: 3,
    carbohydrates: 0,
    calories: 140.26,
    sugar: null,
  },
  {
    food: "Blanc de Poulet Frit",
    type: "Viandes",
    serving: "½ petit blanc de poulet",
    size: 0.5,
    weight: 85,
    protein: 28.42,
    fat: 4,
    carbohydrates: 0.42,
    calories: 158.94,
    sugar: null,
  },
  {
    food: "Jaune d'Œuf",
    type: "Œufs",
    serving: "1 jaune d'œuf",
    size: 1,
    weight: 17,
    protein: 2.7,
    fat: 4.5,
    carbohydrates: 0.6,
    calories: 53.9,
    sugar: 0.1,
  },
  {
    food: "Farine Blanche",
    type: "Pain & Céréales",
    serving: "1 tasse",
    size: 1,
    weight: 125,
    protein: 12.19,
    fat: 1.23,
    carbohydrates: 95.39,
    calories: 455,
    sugar: null,
  },
  {
    food: "Farine de Maïs",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 114,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 0.2,
  },
  {
    food: "Farine de Riz Blanc",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 158,
    protein: 9.4,
    fat: 2.2,
    carbohydrates: 126.6,
    calories: 578.3,
    sugar: null,
  },
  {
    food: "Farine de Riz Complet",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 158,
    protein: 11.4,
    fat: 4.4,
    carbohydrates: 120.8,
    calories: 573.5,
    sugar: 0.5,
  },
  {
    food: "Farine de Blé Complet",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 120,
    protein: 16.4,
    fat: 2.2,
    carbohydrates: 87.1,
    calories: 406.8,
    sugar: 6.7,
  },
  {
    food: "Falafel",
    type: "Légumes",
    serving: "1 pièce",
    size: 1,
    weight: 17,
    protein: 2.3,
    fat: 3,
    carbohydrates: 5.4,
    calories: 56.6,
    sugar: null,
  },
  {
    food: "Tomate",
    type: "Légumes",
    serving: "1 moyenne",
    size: 1,
    weight: 123,
    protein: 1.1,
    fat: 0.2,
    carbohydrates: 4.8,
    calories: 22.1,
    sugar: 3.2,
  },
  {
    food: "Lentilles",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 198,
    protein: 17.9,
    fat: 0.8,
    carbohydrates: 39.9,
    calories: 229.7,
    sugar: 3.6,
  },
  {
    food: "Miel",
    type: "Pain & Céréales",
    serving: "c. à soupe",
    size: 1,
    weight: 21,
    protein: 0.06,
    fat: 0,
    carbohydrates: 17.3,
    calories: 63.84,
    sugar: null,
  },
  {
    food: "Aseedah (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 4.3,
    fat: 11.9,
    carbohydrates: 29.6,
    calories: 243,
    sugar: null,
  },
  {
    food: "Jus d'Ananas",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 250.17,
    protein: 0.8,
    fat: 0.2,
    carbohydrates: 34.48,
    calories: 140.11,
    sugar: null,
  },
  {
    food: "Jus d'Orange",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 248,
    protein: 1.74,
    fat: 0.5,
    carbohydrates: 25.79,
    calories: 111.6,
    sugar: null,
  },
  {
    food: "Jus Orange & Abricot",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 249.39,
    protein: 0.75,
    fat: 0.25,
    carbohydrates: 31.67,
    calories: 127.19,
    sugar: null,
  },
  {
    food: "Jus de Pomme Non Sucré",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 247.79,
    protein: 0.15,
    fat: 0.27,
    carbohydrates: 28.94,
    calories: 116.46,
    sugar: null,
  },
  {
    food: "Jus de Pamplemousse Non Sucré",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 246.99,
    protein: 1.28,
    fat: 0.25,
    carbohydrates: 22.13,
    calories: 93.86,
    sugar: null,
  },
  {
    food: "Jus de Pamplemousse Sucré",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 249.39,
    protein: 1.45,
    fat: 0.22,
    carbohydrates: 27.76,
    calories: 114.72,
    sugar: null,
  },
  {
    food: "Jus de Carotte",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 246,
    protein: 2.34,
    fat: 0.37,
    carbohydrates: 22.88,
    calories: 98.4,
    sugar: null,
  },
  {
    food: "Jus de Goyave",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 239.91,
    protein: 0,
    fat: 0,
    carbohydrates: 21.63,
    calories: 87.86,
    sugar: null,
  },
  {
    food: "Jus de Tomate",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 244,
    protein: 1.8,
    fat: 0.15,
    carbohydrates: 10.32,
    calories: 41.48,
    sugar: null,
  },
  {
    food: "Jus de Fruits Mixés",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 255,
    protein: 0.99,
    fat: 0.18,
    carbohydrates: 48.22,
    calories: 186.15,
    sugar: null,
  },
  {
    food: "Jus de Poire",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 255.78,
    protein: 1.56,
    fat: 0.08,
    carbohydrates: 44.63,
    calories: 181.61,
    sugar: null,
  },
  {
    food: "Jus de Mangue",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 239.91,
    protein: 0,
    fat: 0,
    carbohydrates: 21.63,
    calories: 87.86,
    sugar: null,
  },
  {
    food: "Jus d'Abricot",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 258,
    protein: 1.23,
    fat: 0.23,
    carbohydrates: 55.34,
    calories: 214.14,
    sugar: null,
  },
  {
    food: "Aqeeli (Pain Traditionnel)",
    type: "Plats Traditionnels",
    serving: "tranche",
    size: 1,
    weight: 100,
    protein: 10.1,
    fat: 9.4,
    carbohydrates: 56.7,
    calories: 352,
    sugar: null,
  },
  {
    food: "Aysh Shaylani (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 3.1,
    fat: 3.8,
    carbohydrates: 31.3,
    calories: 172,
    sugar: null,
  },
  {
    food: "Gouj (Fruit Traditionnel)",
    type: "Fruits",
    serving: "1 moyen",
    size: 1,
    weight: 66,
    protein: 0.5,
    fat: 0.2,
    carbohydrates: 7.5,
    calories: 30.4,
    sugar: 6.5,
  },
  {
    food: "Ghouzi au Poulet",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 10.11,
    fat: 3.3,
    carbohydrates: 22.68,
    calories: 160.8,
    sugar: null,
  },
  {
    food: "Ghouzi à l'Agneau",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 11.4,
    fat: 3.4,
    carbohydrates: 22.4,
    calories: 166.9,
    sugar: null,
  },
  {
    food: "Haricots Blancs",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 179,
    protein: 17.4,
    fat: 0.6,
    carbohydrates: 44.9,
    calories: 248.8,
    sugar: 0.6,
  },
  {
    food: "Haricots Jaunes",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 177,
    protein: 16.2,
    fat: 1.9,
    carbohydrates: 44.7,
    calories: 254.9,
    sugar: null,
  },
  {
    food: "Faloodeh (Dessert Traditionnel)",
    type: "Plats Traditionnels",
    serving: "2/3 tasse",
    size: 0.67,
    weight: 100,
    protein: 0.9,
    fat: 0.9,
    carbohydrates: 18.4,
    calories: 85,
    sugar: null,
  },
  {
    food: "Cuisse de Poulet Frite",
    type: "Viandes",
    serving: "cuisse de poulet moyenne",
    size: 1,
    weight: 85,
    protein: 18.5,
    fat: 13.73,
    carbohydrates: 7.41,
    calories: 232,
    sugar: null,
  },
  {
    food: "Cuisse de Poulet Rôtie",
    type: "Viandes",
    serving: "cuisse de poulet moyenne",
    size: 1,
    weight: 85,
    protein: 22,
    fat: 11.45,
    carbohydrates: 0,
    calories: 197.19,
    sugar: null,
  },
  {
    food: "Cuisse de Poulet Frite",
    type: "Viandes",
    serving: "cuisse de poulet moyenne",
    size: 1,
    weight: 85,
    protein: 18.5,
    fat: 13.73,
    carbohydrates: 7.41,
    calories: 232,
    sugar: null,
  },
  {
    food: "Fraises",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 144,
    protein: 1,
    fat: 0.4,
    carbohydrates: 11.1,
    calories: 46.1,
    sugar: 6.7,
  },
  {
    food: "Pistaches Séchées",
    type: "Fruits à Coque",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 5.8,
    fat: 12.4,
    carbohydrates: 7.8,
    calories: 156,
    sugar: 2.9,
  },
  {
    food: "Pistaches Grillées à Sec",
    type: "Fruits à Coque",
    serving: "2 c. à soupe (47 pièces)",
    size: 2,
    weight: 28,
    protein: 6,
    fat: 12.9,
    carbohydrates: 7.7,
    calories: 159.9,
    sugar: 2.9,
  },
  {
    food: "Piment Rouge",
    type: "Légumes",
    serving: "pièce",
    size: 1,
    weight: 45,
    protein: 0.8,
    fat: 0.2,
    carbohydrates: 4,
    calories: 18,
    sugar: 2.4,
  },
  {
    food: "Piment Vert",
    type: "Légumes",
    serving: "pièce",
    size: 1,
    weight: 45,
    protein: 0.9,
    fat: 0.1,
    carbohydrates: 4.3,
    calories: 18,
    sugar: 2.3,
  },
  {
    food: "Fèves de Soja",
    type: "Fruits à Coque",
    serving: "tasse",
    size: 1,
    weight: 172,
    protein: 28.6,
    fat: 15.4,
    carbohydrates: 17.1,
    calories: 297.6,
    sugar: 5.2,
  },
  {
    food: "Fèves de Soja Grillées",
    type: "Fruits à Coque",
    serving: "tasse",
    size: 1,
    weight: 172,
    protein: 60.6,
    fat: 43.7,
    carbohydrates: 57.7,
    calories: 810.1,
    sugar: 30.4,
  },
  {
    food: "Fèves de Soja Grillées à Sec",
    type: "Fruits à Coque",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 11.1,
    fat: 6.1,
    carbohydrates: 9.2,
    calories: 126.3,
    sugar: 2.3,
  },
  {
    food: "Qurs Tabi (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "4 pièces",
    size: 4,
    weight: 100,
    protein: 6.7,
    fat: 18.9,
    carbohydrates: 36.9,
    calories: 345,
    sugar: null,
  },
  {
    food: "Poisson Qurqufan",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 19.9,
    fat: 3.7,
    carbohydrates: 0.4,
    calories: 115,
    sugar: null,
  },
  {
    food: "Poisson Qurqufan Grillé",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 22.8,
    fat: 1.8,
    carbohydrates: 0,
    calories: 108.6,
    sugar: null,
  },
  {
    food: "Zeste d'Orange",
    type: "Fruits",
    serving: "c. à café",
    size: 1,
    weight: 6,
    protein: 0.1,
    fat: null,
    carbohydrates: 1.5,
    calories: 5.8,
    sugar: null,
  },
  {
    food: "Zeste de Citron",
    type: "Fruits",
    serving: "c. à café",
    size: 1,
    weight: 6,
    protein: 0.1,
    fat: null,
    carbohydrates: 1,
    calories: 2.8,
    sugar: 0.3,
  },
  {
    food: "Croûtons",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 30,
    protein: 3.6,
    fat: 2,
    carbohydrates: 22,
    calories: 122.1,
    sugar: null,
  },
  {
    food: "Taro",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 104,
    protein: 1.6,
    fat: 0.2,
    carbohydrates: 27.5,
    calories: 116.5,
    sugar: 0.4,
  },
  {
    food: "Café Instantané",
    type: "Boissons",
    serving: "1,5 tasse",
    size: 1.5,
    weight: 29.86,
    protein: 0.03,
    fat: 0,
    carbohydrates: 0.12,
    calories: 0.6,
    sugar: null,
  },
  {
    food: "Cappuccino",
    type: "Boissons",
    serving: "1,5 tasse",
    size: 1.5,
    weight: 29.3,
    protein: 0.06,
    fat: 0.32,
    carbohydrates: 1.64,
    calories: 9.38,
    sugar: null,
  },
  {
    food: "Qeema (Viande Hachée)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 7.5,
    fat: 4.5,
    carbohydrates: 7.4,
    calories: 100,
    sugar: null,
  },
  {
    food: "Curry de Poulet",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 9.7,
    fat: 1.5,
    carbohydrates: 8,
    calories: 84.7,
    sugar: null,
  },
  {
    food: "Curry de Poisson",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 13,
    fat: 2,
    carbohydrates: 3.8,
    calories: 86.6,
    sugar: null,
  },
  {
    food: "Curry de Viande",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 15.3,
    fat: 2.8,
    carbohydrates: 3,
    calories: 99.4,
    sugar: null,
  },
  {
    food: "Kastar (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 2.8,
    fat: 3.1,
    carbohydrates: 12.6,
    calories: 90,
    sugar: null,
  },
  {
    food: "Kebab",
    type: "Plats Traditionnels",
    serving: "4 pièces",
    size: 4,
    weight: 100,
    protein: 8.1,
    fat: 12.6,
    carbohydrates: 33.7,
    calories: 281,
    sugar: null,
  },
  {
    food: "Kebab d'Agneau",
    type: "Plats Traditionnels",
    serving: "taille paume (morceaux)",
    size: 1,
    weight: 100,
    protein: 25.16,
    fat: 12.96,
    carbohydrates: 1.55,
    calories: 223,
    sugar: null,
  },
  {
    food: "Foie de Poulet",
    type: "Viandes",
    serving: "3 pièces moyennes",
    size: 3,
    weight: 85,
    protein: 20.72,
    fat: 4.65,
    carbohydrates: 0.75,
    calories: 133.5,
    sugar: null,
  },
  {
    food: "Foie de Bœuf Cuit",
    type: "Viandes",
    serving: "4 pièces moyennes",
    size: 4,
    weight: 85,
    protein: 22.73,
    fat: 6.81,
    carbohydrates: 6.67,
    calories: 184.45,
    sugar: null,
  },
  {
    food: "Oignon Vert / Ciboule",
    type: "Légumes",
    serving: "botte (tasse)",
    size: 1,
    weight: 89,
    protein: 1.3,
    fat: 0.3,
    carbohydrates: 12.6,
    calories: 54.3,
    sugar: 3.5,
  },
  {
    food: "Céleri",
    type: "Légumes",
    serving: "1 moyen",
    size: 1,
    weight: 40,
    protein: 0.3,
    fat: 0.1,
    carbohydrates: 1.2,
    calories: 6.4,
    sugar: 0.7,
  },
  {
    food: "Croissant au Fromage",
    type: "Pain & Céréales",
    serving: "pièce moyenne",
    size: 1,
    weight: 57,
    protein: 5.24,
    fat: 11.91,
    carbohydrates: 26.79,
    calories: 235.98,
    sugar: null,
  },
  {
    food: "Croissant au Beurre",
    type: "Pain & Céréales",
    serving: "pièce moyenne",
    size: 1,
    weight: 57,
    protein: 4.67,
    fat: 11.97,
    carbohydrates: 26.11,
    calories: 231.42,
    sugar: null,
  },
  {
    food: "Crème pour Café (légère)",
    type: "Crèmes",
    serving: "c. à soupe",
    size: 1,
    weight: 15,
    protein: 0.4,
    fat: 2.9,
    carbohydrates: 0.5,
    calories: 29.2,
    sugar: null,
  },
  {
    food: "Crème en Poudre",
    type: "Crèmes",
    serving: "c. à soupe",
    size: 1,
    weight: 6,
    protein: 0.3,
    fat: 2.1,
    carbohydrates: 3.3,
    calories: 32.7,
    sugar: 3.3,
  },
  {
    food: "Crème en Poudre Allégée",
    type: "Crèmes",
    serving: "c. à soupe",
    size: 1,
    weight: 6,
    protein: 0.1,
    fat: 0.9,
    carbohydrates: 4.4,
    calories: 25.9,
    sugar: 4.4,
  },
  {
    food: "Crème Aigre Sans Matières Grasses",
    type: "Crèmes",
    serving: "2 c. à soupe",
    size: 2,
    weight: 30,
    protein: 0.9,
    fat: 0,
    carbohydrates: 4.7,
    calories: 22.2,
    sugar: 0.1,
  },
  {
    food: "Crème Aigre Allégée",
    type: "Crèmes",
    serving: "2 c. à soupe",
    size: 2,
    weight: 30,
    protein: 2.1,
    fat: 4.2,
    carbohydrates: 2.1,
    calories: 54.3,
    sugar: 0.1,
  },
  {
    food: "Crème Liquide (légère)",
    type: "Crèmes",
    serving: "c. à soupe",
    size: 1,
    weight: 30,
    protein: 0.2,
    fat: 1,
    carbohydrates: 2.7,
    calories: 21.3,
    sugar: 2.7,
  },
  {
    food: "Poire",
    type: "Fruits",
    serving: "1 moyenne",
    size: 1,
    weight: 166,
    protein: 0.6,
    fat: 0.2,
    carbohydrates: 25.7,
    calories: 96.3,
    sugar: 16.3,
  },
  {
    food: "Poire Séchée",
    type: "Fruits",
    serving: "10 moitiés",
    size: 10,
    weight: 175,
    protein: 3.3,
    fat: 1.1,
    carbohydrates: 122,
    calories: 458.5,
    sugar: 108.8,
  },
  {
    food: "Poisson Roi (Kanaad)",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 19.5,
    fat: 9.3,
    carbohydrates: 0,
    calories: 161,
    sugar: null,
  },
  {
    food: "Poisson Roi Frit",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 26.7,
    fat: 11.9,
    carbohydrates: 0,
    calories: 213.7,
    sugar: null,
  },
  {
    food: "Coca Light",
    type: "Boissons",
    serving: "1,5 tasse",
    size: 1.5,
    weight: 369,
    protein: 0.2,
    fat: 0,
    carbohydrates: 0.3,
    calories: 2,
    sugar: null,
  },
  {
    food: "Coca Normal",
    type: "Boissons",
    serving: "1,5 tasse",
    size: 1.5,
    weight: 369,
    protein: 0.1,
    fat: 0.1,
    carbohydrates: 38.5,
    calories: 151,
    sugar: null,
  },
  {
    food: "KitKat",
    type: "Collations",
    serving: "1 pièce",
    size: 1,
    weight: 46,
    protein: 3.08,
    fat: 13.11,
    carbohydrates: 28.47,
    calories: 234.6,
    sugar: null,
  },
  {
    food: "Muffin Nature",
    type: "Pain & Céréales",
    serving: "grand",
    size: 1,
    weight: 65,
    protein: 4.49,
    fat: 7.41,
    carbohydrates: 26.91,
    calories: 192.4,
    sugar: null,
  },
  {
    food: "Quinoa",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 170,
    protein: 24,
    fat: 10.3,
    carbohydrates: 109.1,
    calories: 625.6,
    sugar: null,
  },
  {
    food: "Kiwi",
    type: "Fruits",
    serving: "1 moyen",
    size: 1,
    weight: 76,
    protein: 0.9,
    fat: 0.4,
    carbohydrates: 11.1,
    calories: 46.4,
    sugar: 6.8,
  },
  {
    food: "Labneh",
    type: "Produits Laitiers",
    serving: "tasse",
    size: 1,
    weight: 100,
    protein: 12.9,
    fat: 10.8,
    carbohydrates: 1,
    calories: 154,
    sugar: null,
  },
  {
    food: "Bœuf Haché Bouilli",
    type: "Viandes",
    serving: "2 c. à soupe",
    size: 2,
    weight: 85,
    protein: 20.45,
    fat: 17.6,
    carbohydrates: 0,
    calories: 245.65,
    sugar: null,
  },
  {
    food: "Bœuf Haché Frit",
    type: "Viandes",
    serving: "2 c. à soupe",
    size: 2,
    weight: 85,
    protein: 20.33,
    fat: 19.2,
    carbohydrates: 0,
    calories: 260,
    sugar: null,
  },
  {
    food: "Veau Cuit",
    type: "Viandes",
    serving: "3 petits morceaux",
    size: 3,
    weight: 85,
    protein: 23.99,
    fat: 8,
    carbohydrates: 0,
    calories: 175,
    sugar: null,
  },
  {
    food: "Luqaimat (Beignets Traditionnels)",
    type: "Plats Traditionnels",
    serving: "5 pièces",
    size: 5,
    weight: 100,
    protein: 3,
    fat: 9.5,
    carbohydrates: 44.4,
    calories: 275,
    sugar: null,
  },
  {
    food: "Amandes",
    type: "Fruits à Coque",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 5.9,
    fat: 13.8,
    carbohydrates: 6.1,
    calories: 161,
    sugar: 1.3,
  },
  {
    food: "Citron",
    type: "Fruits",
    serving: "1 moyen",
    size: 1,
    weight: 58,
    protein: 0.6,
    fat: 0.2,
    carbohydrates: 5.4,
    calories: 16.8,
    sugar: 1.4,
  },
  {
    food: "Limonade",
    type: "Boissons",
    serving: "1,5 tasse",
    size: 1.5,
    weight: 355,
    protein: 0,
    fat: 0,
    carbohydrates: 38.4,
    calories: 149,
    sugar: null,
  },
  {
    food: "Eau de Coco",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 240,
    protein: 1.7,
    fat: 0.5,
    carbohydrates: 8.9,
    calories: 45.6,
    sugar: 6.3,
  },
  {
    food: "Mangue",
    type: "Fruits",
    serving: "1 moyenne",
    size: 1,
    weight: 207,
    protein: 1.1,
    fat: 0.6,
    carbohydrates: 35.2,
    calories: 134.6,
    sugar: 30.6,
  },
  {
    food: "Mayonnaise",
    type: "Matières Grasses",
    serving: "c. à café",
    size: 1,
    weight: 14.7,
    protein: 0.13,
    fat: 4.91,
    carbohydrates: 3.51,
    calories: 57.29,
    sugar: null,
  },
  {
    food: "Machboos au Poulet",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 17,
    fat: 2.39,
    carbohydrates: 17.2,
    calories: 158.36,
    sugar: null,
  },
  {
    food: "Machboos à l'Agneau",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 16.89,
    fat: 3,
    carbohydrates: 16.87,
    calories: 166.5,
    sugar: null,
  },
  {
    food: "Courgette Farcie",
    type: "Plats Traditionnels",
    serving: "pièce",
    size: 1,
    weight: 100,
    protein: 4.86,
    fat: 1.51,
    carbohydrates: 14.67,
    calories: 86.37,
    sugar: null,
  },
  {
    food: "Feuilles de Vigne Farcies",
    type: "Plats Traditionnels",
    serving: "4 pièces",
    size: 4,
    weight: 100,
    protein: 7.47,
    fat: 2.73,
    carbohydrates: 16.11,
    calories: 125.2,
    sugar: null,
  },
  {
    food: "Muhallabia (Pudding au Lait)",
    type: "Plats Traditionnels",
    serving: "2/3 tasse",
    size: 0.67,
    weight: 100,
    protein: 2.9,
    fat: 2.9,
    carbohydrates: 17.6,
    calories: 108,
    sugar: null,
  },
  {
    food: "Bouillon de Poisson",
    type: "Plats Traditionnels",
    serving: "1/2",
    size: 0.5,
    weight: 100,
    protein: 7,
    fat: 5.8,
    carbohydrates: 0.5,
    calories: 82,
    sugar: null,
  },
  {
    food: "Champignon",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 70,
    protein: 2.2,
    fat: 0.2,
    carbohydrates: 2.3,
    calories: 15.4,
    sugar: 1.2,
  },
  {
    food: "Abricot",
    type: "Fruits",
    serving: "3 pièces",
    size: 3,
    weight: 105,
    protein: 1.5,
    fat: 0.4,
    carbohydrates: 11.7,
    calories: 50.4,
    sugar: 9.7,
  },
  {
    food: "Abricot Sec",
    type: "Fruits",
    serving: "tasse",
    size: 1,
    weight: 65,
    protein: 2.2,
    fat: 0.3,
    carbohydrates: 40.7,
    calories: 156.6,
    sugar: 34.7,
  },
  {
    food: "Madrouba (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/2",
    size: 0.5,
    weight: 100,
    protein: 8.55,
    fat: 0.9,
    carbohydrates: 5.34,
    calories: 63.6,
    sugar: null,
  },
  {
    food: "Concentré de Tomate",
    type: "Légumes",
    serving: "168g (boîte)",
    size: 1,
    weight: 170,
    protein: 7.3,
    fat: 0.8,
    carbohydrates: 32.1,
    calories: 139.4,
    sugar: 17.7,
  },
  {
    food: "Pâtes au Poulet",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 17.9,
    fat: 1.9,
    carbohydrates: 10,
    calories: 129.7,
    sugar: null,
  },
  {
    food: "Pâtes Cuites",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 140,
    protein: 6.68,
    fat: 0.94,
    carbohydrates: 39.68,
    calories: 197.4,
    sugar: null,
  },
  {
    food: "Noix de Maïs",
    type: "Fruits à Coque",
    serving: "2 c. à soupe",
    size: 2,
    weight: 28,
    protein: 2.4,
    fat: 4.4,
    carbohydrates: 20.1,
    calories: 124.9,
    sugar: 0.2,
  },
  {
    food: "Mélange de Noix Grillées",
    type: "Fruits à Coque",
    serving: "1/8 tasse",
    size: 0.125,
    weight: 28,
    protein: 4.8,
    fat: 14.4,
    carbohydrates: 7.1,
    calories: 166.3,
    sugar: 2.5,
  },
  {
    food: "Mélange de Noix Grillées à l'Huile",
    type: "Fruits à Coque",
    serving: "1/8 tasse",
    size: 0.125,
    weight: 28,
    protein: 4.7,
    fat: 15.8,
    carbohydrates: 6,
    calories: 172.8,
    sugar: 2.8,
  },
  {
    food: "Mandi au Poulet",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 14.6,
    fat: 2.3,
    carbohydrates: 17.9,
    calories: 154.9,
    sugar: null,
  },
  {
    food: "Mandi à l'Agneau",
    type: "Plats Traditionnels",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 11.9,
    fat: 1.9,
    carbohydrates: 20.34,
    calories: 147,
    sugar: null,
  },
  {
    food: "Banane",
    type: "Fruits",
    serving: "1 moyenne",
    size: 1,
    weight: 118,
    protein: 1.3,
    fat: 0.4,
    carbohydrates: 27,
    calories: 105,
    sugar: 14.4,
  },
  {
    food: "Poisson Meid",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 18.3,
    fat: 16.1,
    carbohydrates: 0,
    calories: 216.7,
    sugar: null,
  },
  {
    food: "Poisson Meid Grillé",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 24.2,
    fat: 10.5,
    carbohydrates: 0,
    calories: 191.2,
    sugar: null,
  },
  {
    food: "Son de Maïs",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 76,
    protein: 6.4,
    fat: 0.7,
    carbohydrates: 65.1,
    calories: 170.2,
    sugar: 0.2,
  },
  {
    food: "Son de Riz",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 118,
    protein: 15.8,
    fat: 24.6,
    carbohydrates: 58.6,
    calories: 372.9,
    sugar: 5.4,
  },
  {
    food: "Son de Blé",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 58,
    protein: 9,
    fat: 2.5,
    carbohydrates: 37.4,
    calories: 125.3,
    sugar: 2.7,
  },
  {
    food: "Nafish (Collation Traditionnelle)",
    type: "Collations",
    serving: "tasse",
    size: 1,
    weight: 11,
    protein: 0.99,
    fat: 3.09,
    carbohydrates: 6.29,
    calories: 55,
    sugar: null,
  },
  {
    food: "Nectar de Poire",
    type: "Boissons",
    serving: "tasse",
    size: 1,
    weight: 248.59,
    protein: 0.67,
    fat: 0.05,
    carbohydrates: 34.6,
    calories: 134.24,
    sugar: null,
  },
  {
    food: "Nectar d'Abricot",
    type: "Boissons",
    serving: "3/4 tasse",
    size: 0.75,
    weight: 250.99,
    protein: 0.93,
    fat: 0.23,
    carbohydrates: 36.12,
    calories: 140.55,
    sugar: null,
  },
  {
    food: "Nectarine",
    type: "Fruits",
    serving: "1 moyenne",
    size: 1,
    weight: 136,
    protein: 1.4,
    fat: 0.4,
    carbohydrates: 14.3,
    calories: 59.8,
    sugar: 10.7,
  },
  {
    food: "Nouilles Cuites",
    type: "Pain & Céréales",
    serving: "tasse",
    size: 1,
    weight: 160,
    protein: 7.6,
    fat: 2.35,
    carbohydrates: 39.74,
    calories: 212.8,
    sugar: null,
  },
  {
    food: "Mérou (Hamour)",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 19.3,
    fat: 3.4,
    carbohydrates: 0.2,
    calories: 109.3,
    sugar: null,
  },
  {
    food: "Hamour au Riz",
    type: "Viandes",
    serving: "1/2 tasse",
    size: 0.5,
    weight: 100,
    protein: 27.3,
    fat: 3.2,
    carbohydrates: 0,
    calories: 139.2,
    sugar: null,
  },
  {
    food: "Harees (Traditionnel)",
    type: "Plats Traditionnels",
    serving: "1/4 tasse",
    size: 0.25,
    weight: 100,
    protein: 9,
    fat: 0.7,
    carbohydrates: 8.3,
    calories: 76,
    sugar: null,
  },
  {
    food: "Asperges",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 134,
    protein: 2.9,
    fat: 0.2,
    carbohydrates: 5.2,
    calories: 26.8,
    sugar: 2.5,
  },
  {
    food: "Feuilles de Vigne",
    type: "Légumes",
    serving: "tasse",
    size: 1,
    weight: 14,
    protein: 0.8,
    fat: 0.3,
    carbohydrates: 2.4,
    calories: 13,
    sugar: 0.9,
  },
  {
    food: "Poisson Yanam",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 17.9,
    fat: 10.4,
    carbohydrates: 0,
    calories: 164.7,
    sugar: null,
  },
  {
    food: "Poisson Yanam Grillé",
    type: "Viandes",
    serving: "taille paume",
    size: 1,
    weight: 100,
    protein: 25.9,
    fat: 5.6,
    carbohydrates: 0,
    calories: 154.8,
    sugar: null,
  },
];
export default foodData;